import { Box, CircularProgress, Typography } from "@mui/material";
import { FC, useCallback, useEffect, useState } from "react";

interface Props {
  url: string;
}

const MetabaseDashboard: FC<Props> = ({ url }) => {
  const [iframeHeight, setIframeHeight] = useState(window.innerHeight);
  const [isLoading, setIsLoading] = useState(true);

  const updateIframeHeight = useCallback(() => {
    setIframeHeight(window.innerHeight);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", updateIframeHeight);
    return () => {
      window.removeEventListener("resize", updateIframeHeight);
    };
  }, [updateIframeHeight]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          minHeight: isLoading ? "400px" : iframeHeight, // 400px mientras se carga
          position: "relative",
          width: "100%",
          height: isLoading ? "auto" : iframeHeight, // Ajusta la altura solo después de cargar
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Sombra leve
          borderRadius: "8px", // Bordes redondeados opcionales
          overflow: "hidden", // Asegura que la sombra no se "desborde"
        }}
      >
        {/* Contenedor de carga centrado */}
        {isLoading && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              bgcolor: "rgba(255, 255, 255, 0.7)",
            }}
          >
            <CircularProgress />
            <Typography component="p" sx={{ marginTop: 2 }}>
              Cargando...
            </Typography>
          </Box>
        )}

        {/* iframe cargando */}
        <iframe
          src={url}
          title="Metabase Dashboard"
          style={{
            width: "100%",
            height: "100%", // Asegura que el iframe ocupa todo el contenedor
            border: "none",
            display: isLoading ? "none" : "block", // Oculta el iframe mientras carga
          }}
          onLoad={() => setIsLoading(false)} // Cuando el iframe termina de cargar, ocultamos el spinner
        />
      </Box>
    </Box>
  );
};

export default MetabaseDashboard;
